<!-- PART 0/7: MODERN COMPACT FILTER - MUCH CLEANER! -->
<!-- Breadcrumb & Container Opening -->
<div>
    <!-- Breadcrumb -->
    <ul class="flex space-x-2 rtl:space-x-reverse mb-6">
        <li>
            <a href="javascript:;" class="text-primary hover:underline">Tableau de bord</a>
        </li>
        <li class="before:content-['/'] ltr:before:mr-2 rtl:before:ml-2">
            <span>Accueil</span>
        </li>
    </ul>

    <!-- Clean & Modern Filter Bar -->
    <div
        class="flex flex-wrap items-center justify-between gap-4 mb-6 p-4 bg-white dark:bg-black rounded-xl shadow-sm border border-gray-200/50 dark:border-gray-700/50">
        <!-- Left Side: Filter Controls -->
        <div class="flex items-center gap-3">
            <!-- Mode Selection Buttons -->
            <div class="flex items-center bg-gray-100 dark:bg-gray-800 rounded-lg p-1">
                <!-- Aujourd'hui Button -->
                <button type="button" (click)="setTodayMode()"
                    class="flex items-center mr-1 gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md transition-all"
                    [ngClass]="{
                        'bg-primary text-white shadow-sm': flagToday,
                        'text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700': !flagToday
                    }">
                    <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                        <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Aujourd'hui
                </button>

                <!-- Filtrer Button -->
                <button type="button" (click)="setFilterMode()"
                    class="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md transition-all"
                    [ngClass]="{
                        'bg-primary text-white shadow-sm': !flagToday,
                        'text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700': flagToday
                    }">
                    <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 4H21V6H20L16 10V16H8V10L4 6H3V4Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Filtrer
                </button>
            </div>

            <!-- Filter Controls - Only show when in filter mode -->
            <div class="flex items-center gap-3" *ngIf="!flagToday">
                <!-- Filter Icon & Label -->
                <div class="flex items-center gap-2 text-gray-600 dark:text-gray-300">
                    <span class="text-sm font-medium">Période:</span>
                </div>

                <!-- Year Dropdown -->
                <div class="relative">
                    <select [(ngModel)]="selectedYear" (ngModelChange)="onYearChange()"
                        class="appearance-none bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg px-3 py-2 pr-8 text-sm font-medium text-gray-700 dark:text-gray-200 hover:border-primary focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all cursor-pointer min-w-[90px]" [class.border-primary]="selectedYear">
                        <option [value]="null">Toutes les années</option>
                        <option *ngFor="let year of availableYears" [value]="year.value">{{year.label}}</option>
                    </select>
                    <svg class="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
                        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>

                <!-- Month Dropdown -->
                <div class="relative">
                    <select [(ngModel)]="selectedMonth" (ngModelChange)="onMonthChange()" [disabled]="!selectedYear"
                        class="appearance-none bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg px-3 py-2 pr-8 text-sm font-medium text-gray-700 dark:text-gray-200 hover:border-primary focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all cursor-pointer min-w-[110px] disabled:opacity-50 disabled:cursor-not-allowed" [class.border-primary]="selectedMonth">
                        <option [value]="null">Tous les mois</option>
                        <option *ngFor="let month of availableMonths" [value]="month.value">{{month.label}}</option>
                    </select>
                    <svg class="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
                        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
            </div>

        </div>

        <!-- Right Side: Period Display Badge -->
        <div class="flex items-center gap-2">
            <!-- Period Display Badge bg-primary/10 dark:bg-primary/20 text-primary dark:text-primary-light -->
            <div class="flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300" >
                <svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                    <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
                <span *ngIf="flagToday">Aujourd'hui</span>
                <span *ngIf="!flagToday && getSelectedPeriodLabel()">{{getSelectedPeriodLabel()}}</span>
                <span *ngIf="!flagToday && !getSelectedPeriodLabel()">Toutes les données</span>
            </div>
        </div>
    </div>

    <!-- PART 1/7: Adherent Section Start -->
    <div class="pt-5">
        <!-- Demandes Adhérent Section - Only show if user has access to any adherent modules -->
        <div class="mb-8" *ngIf="shouldShowAdherentSection()">
            <div class="flex items-center justify-between mb-6">
                <h3 class="text-2xl font-bold text-gray-800 dark:text-white-light flex items-center">
                    <div class="h-8 w-1 bg-primary rounded-full mr-3"></div>
                    Demandes Adhérent
                </h3>
                <div class="text-sm text-gray-500 dark:text-white-dark">
                    {{ getTotalAdherentRequests() }} demandes au total
                </div>
            </div>

            <div class="grid gap-6 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6">
                <!-- PART 2/6: Adherent Cards 1-3 (Feuilles de soins, Prises en charge, Famille et Adhésion) -->
                <!-- Demandes Feuilles de soins - Show only if user has FDSP permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-warning/20 min-h-[200px]"
                    *ngIf="hasAccess('FDSA')" (click)="navigateToRoute('/feuilles-de-soins/ADH', 'FDSA', true)">
                    <div class="p-6 relative overflow-hidden h-full flex flex-col">
                        <div
                            class="absolute inset-0 bg-gradient-to-br from-warning/5 to-warning/10 dark:from-warning/10 dark:to-warning/20">
                        </div>
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div
                                    class="flex h-12 w-12 items-center justify-center rounded-xl bg-warning/20 text-warning dark:bg-warning dark:text-warning-light shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <!-- En cours indicator -->
                                <div class="flex flex-col items-end">
                                    <div class="text-xs text-orange-500 font-medium">En cours</div>
                                    <div class="text-sm font-bold text-orange-600">{{
                                        adherentStats?.feuillesSoinsEnCours || 0 }}</div>
                                </div>
                            </div>
                            <h5 class="text-3xl font-bold text-gray-800 dark:text-white-light mb-2">{{
                                adherentStats?.feuillesSoins || 0 }}</h5>
                            <div class="space-y-1">
                                <span class="text-sm font-semibold text-gray-700 dark:text-white-dark">Demandes</span>
                                <p class="text-xs text-warning font-medium">Soins ambulatoires</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Demandes Prises en charge - Show only if user has PECP permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-success/20 min-h-[200px]"
                    *ngIf="hasAccess('PECA')" (click)="navigateToRoute('/prise-en-charge/ADH', 'PECA', true)">
                    <div class="p-6 relative overflow-hidden h-full flex flex-col">
                        <div
                            class="absolute inset-0 bg-gradient-to-br from-success/5 to-success/10 dark:from-success/10 dark:to-success/20">
                        </div>
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div
                                    class="flex h-12 w-12 items-center justify-center rounded-xl bg-success/20 text-success dark:bg-success dark:text-success-light shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <!-- En cours indicator -->
                                <div class="flex flex-col items-end">
                                    <div class="text-xs text-orange-500 font-medium">En cours</div>
                                    <div class="text-sm font-bold text-orange-600">{{
                                        adherentStats?.prisesEnChargeEnCours || 0 }}</div>
                                </div>
                            </div>
                            <h5 class="text-3xl font-bold text-gray-800 dark:text-white-light mb-2">{{
                                adherentStats?.prisesEnCharge || 0 }}</h5>
                            <div class="space-y-1">
                                <span class="text-sm font-semibold text-gray-700 dark:text-white-dark">Demandes</span>
                                <p class="text-xs text-success font-medium">Prises en charge</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Demandes Famille et Adhésion - Show only if user has ADHE permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-info/20 min-h-[200px]"
                    *ngIf="hasAccess('ADHA')" (click)="navigateToRoute('/adhesion/ADH', 'ADHA', true)">
                    <div class="p-6 relative overflow-hidden h-full flex flex-col">
                        <div
                            class="absolute inset-0 bg-gradient-to-br from-info/5 to-info/10 dark:from-info/10 dark:to-info/20">
                        </div>
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div
                                    class="flex h-12 w-12 items-center justify-center rounded-xl bg-info/20 text-info dark:bg-info dark:text-info-light shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M23 21V19C23 17.9391 22.5786 16.9217 21.8284 16.1716C21.0783 15.4214 20.0609 15 19 15H18"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <!-- En cours indicator -->
                                <div class="flex flex-col items-end">
                                    <div class="text-xs text-orange-500 font-medium">En cours</div>
                                    <div class="text-sm font-bold text-orange-600">{{
                                        adherentStats?.familleAdhesionEnCours || 0 }}</div>
                                </div>
                            </div>
                            <h5 class="text-3xl font-bold text-gray-800 dark:text-white-light mb-2">{{
                                adherentStats?.familleAdhesion || 0 }}</h5>
                            <div class="space-y-1">
                                <span class="text-sm font-semibold text-gray-700 dark:text-white-dark">Demandes</span>
                                <p class="text-xs text-info font-medium">Famille et Adhésion</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PART 3/6: Adherent Cards 4-6 (ALD, EP, Réclamations) & Partenaire Section Start -->
                <!-- Demandes Affections Longue Durée - Show only if user has ALDA permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-danger/20 min-h-[200px]"
                    *ngIf="hasAccess('ALDA')" (click)="navigateToRoute('/affection-longue-duree/ADH', 'ALDA', true)">
                    <div class="p-6 relative overflow-hidden h-full flex flex-col">
                        <div
                            class="absolute inset-0 bg-gradient-to-br from-danger/5 to-danger/10 dark:from-danger/10 dark:to-danger/20">
                        </div>
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div
                                    class="flex h-12 w-12 items-center justify-center rounded-xl bg-danger/20 text-danger dark:bg-danger dark:text-danger-light shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22 12H18L15 21L9 3L6 12H2" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <!-- En cours indicator -->
                                <div class="flex flex-col items-end">
                                    <div class="text-xs text-orange-500 font-medium">En cours</div>
                                    <div class="text-sm font-bold text-orange-600">{{
                                        adherentStats?.affectionsLongueDureeEnCours || 0 }}</div>
                                </div>
                            </div>
                            <h5 class="text-3xl font-bold text-gray-800 dark:text-white-light mb-2">{{
                                adherentStats?.affectionsLongueDuree || 0 }}</h5>
                            <div class="space-y-1">
                                <span class="text-sm font-semibold text-gray-700 dark:text-white-dark">Demandes</span>
                                <p class="text-xs text-danger font-medium">Affections Longue Durée</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Demandes Ententes Préalables - Show only if user has EPA permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-purple-500/20 min-h-[200px]"
                    *ngIf="hasAccess('EPA')" (click)="navigateToRoute('/ententes-prealables/ADH', 'EPA', true)">
                    <div class="p-6 relative overflow-hidden h-full flex flex-col">
                        <div
                            class="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-purple-500/10 dark:from-purple-500/10 dark:to-purple-500/20">
                        </div>
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div
                                    class="flex h-12 w-12 items-center justify-center rounded-xl bg-purple-500/20 text-purple-500 dark:bg-purple-500 dark:text-purple-100 shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <!-- En cours indicator -->
                                <div class="flex flex-col items-end">
                                    <div class="text-xs text-orange-500 font-medium">En cours</div>
                                    <div class="text-sm font-bold text-orange-600">{{
                                        adherentStats?.ententesPrealablesEnCours || 0 }}</div>
                                </div>
                            </div>
                            <h5 class="text-3xl font-bold text-gray-800 dark:text-white-light mb-2">{{
                                adherentStats?.ententesPrealables || 0 }}</h5>
                            <div class="space-y-1">
                                <span class="text-sm font-semibold text-gray-700 dark:text-white-dark">Demandes</span>
                                <p class="text-xs text-purple-500 font-medium">Ententes Préalables</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Demandes Réclamations - Show only if user has RECA permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-secondary/20 min-h-[200px]"
                    *ngIf="hasAccess('RECA')" (click)="navigateToRoute('/reclamations/ADH', 'RECA', true)">
                    <div class="p-6 relative overflow-hidden h-full flex flex-col">
                        <div
                            class="absolute inset-0 bg-gradient-to-br from-secondary/5 to-secondary/10 dark:from-secondary/10 dark:to-secondary/20">
                        </div>
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div
                                    class="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary/20 text-secondary dark:bg-secondary dark:text-secondary-light shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                                        <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" />
                                        <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" />
                                    </svg>
                                </div>
                                <!-- En cours indicator -->
                                <div class="flex flex-col items-end">
                                    <div class="text-xs text-orange-500 font-medium">En cours</div>
                                    <div class="text-sm font-bold text-orange-600">{{ adherentStats?.reclamationsEnCours
                                        || 0 }}</div>
                                </div>
                            </div>
                            <h5 class="text-3xl font-bold text-gray-800 dark:text-white-light mb-2">{{
                                adherentStats?.reclamations || 0 }}</h5>
                            <div class="space-y-1">
                                <span class="text-sm font-semibold text-gray-700 dark:text-white-dark">Demandes</span>
                                <p class="text-xs text-secondary font-medium">Réclamations</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Demandes Partenaire Section - Only show if user has access to any partenaire modules -->
        <div class="mb-8" *ngIf="shouldShowPartenaireSection()">
            <div class="flex items-center justify-between mb-6">
                <h3 class="text-2xl font-bold text-gray-800 dark:text-white-light flex items-center">
                    <div class="h-8 w-1 bg-purple-500 rounded-full mr-3"></div>
                    Demandes Partenaire
                </h3>
                <div class="text-sm text-gray-500 dark:text-white-dark">
                    {{ getTotalPartenaireRequests() }} demandes au total
                </div>
            </div>

            <div class="grid gap-4 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3">
                <!-- PART 4/6: Partenaire Cards & Actions Rapides Section Start -->
                <!-- Demandes Prises en charge Partenaire - Show only if user has PPCP permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-success/20"
                    *ngIf="hasAccess('PECP')" (click)="navigateToRoute('/prise-en-charge/PTR', 'PECP', true)">
                    <div class="p-6 relative overflow-hidden">
                        <div
                            class="absolute inset-0 bg-gradient-to-br from-success/5 to-success/10 dark:from-success/10 dark:to-success/20">
                        </div>
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div
                                    class="flex h-12 w-12 items-center justify-center rounded-xl bg-success/20 text-success dark:bg-success dark:text-success-light shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9 11H15M9 15H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <!-- En cours indicator -->
                                <div class="flex flex-col items-end">
                                    <div class="text-xs text-orange-500 font-medium">En cours</div>
                                    <div class="text-sm font-bold text-orange-600">{{
                                        partenaireStats?.prisesEnChargeEnCours || 0 }}</div>
                                </div>
                            </div>
                            <h5 class="text-3xl font-bold text-gray-800 dark:text-white-light mb-2">{{
                                partenaireStats?.prisesEnCharge || 0 }}</h5>
                            <div class="space-y-1">
                                <span class="text-sm font-semibold text-gray-700 dark:text-white-dark">Demandes</span>
                                <p class="text-xs text-success font-medium">Prises en charge</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Demandes Informations - Show only if user has INFO permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-info/20"
                    *ngIf="hasAccess('INFO')" (click)="navigateToRoute('/adhesion/PTR', 'INFO', true)">
                    <div class="p-6 relative overflow-hidden">
                        <div
                            class="absolute inset-0 bg-gradient-to-br from-info/5 to-info/10 dark:from-info/10 dark:to-info/20">
                        </div>
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div
                                    class="flex h-12 w-12 items-center justify-center rounded-xl bg-info/20 text-info dark:bg-info dark:text-info-light shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                                        <line x1="12" y1="16" x2="12" y2="12" stroke="currentColor" stroke-width="2" />
                                        <line x1="12" y1="8" x2="12.01" y2="8" stroke="currentColor" stroke-width="2" />
                                    </svg>
                                </div>
                                <!-- En cours indicator -->
                                <div class="flex flex-col items-end">
                                    <div class="text-xs text-orange-500 font-medium">En cours</div>
                                    <div class="text-sm font-bold text-orange-600">{{
                                        partenaireStats?.informationsEnCours || 0 }}</div>
                                </div>
                            </div>
                            <h5 class="text-3xl font-bold text-gray-800 dark:text-white-light mb-2">{{
                                partenaireStats?.informations || 0 }}</h5>
                            <div class="space-y-1">
                                <span class="text-sm font-semibold text-gray-700 dark:text-white-dark">Demandes</span>
                                <p class="text-xs text-info font-medium">Informations</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Demandes Réclamations Partenaire - Show only if user has RECP permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-secondary/20"
                    *ngIf="hasAccess('RECP')" (click)="navigateToRoute('/reclamations/PTR', 'RECP', true)">
                    <div class="p-6 relative overflow-hidden">
                        <div
                            class="absolute inset-0 bg-gradient-to-br from-secondary/5 to-secondary/10 dark:from-secondary/10 dark:to-secondary/20">
                        </div>
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div
                                    class="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary/20 text-secondary dark:bg-secondary dark:text-secondary-light shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                                        <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" />
                                        <line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" />
                                    </svg>
                                </div>
                                <!-- En cours indicator -->
                                <div class="flex flex-col items-end">
                                    <div class="text-xs text-orange-500 font-medium">En cours</div>
                                    <div class="text-sm font-bold text-orange-600">{{
                                        partenaireStats?.reclamationsEnCours || 0 }}</div>
                                </div>
                            </div>
                            <h5 class="text-3xl font-bold text-gray-800 dark:text-white-light mb-2">{{
                                partenaireStats?.reclamations || 0 }}</h5>
                            <div class="space-y-1">
                                <span class="text-sm font-semibold text-gray-700 dark:text-white-dark">Demandes</span>
                                <p class="text-xs text-secondary font-medium">Réclamations</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Actions Rapides Section - Only show if user has access to any admin modules -->
        <div class="mb-8" *ngIf="shouldShowActionsRapides()">
            <div class="flex items-center justify-between mb-6">
                <h3 class="text-2xl font-bold text-gray-800 dark:text-white-light flex items-center">
                    <div class="h-8 w-1 bg-orange-500 rounded-full mr-3"></div>
                    Actions Rapides
                </h3>
            </div>
            <!-- PART 5/6: Actions Rapides Cards -->
            <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <!-- Dossier Hors Casa - Show only if user has DSHC permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-[#4361ee]/20 min-h-[180px] bg-white dark:bg-[#0e1726]"
                    *ngIf="hasAccess('DSHC')" (click)="navigateToRoute('/dossier-hors-casa', 'DSHC')">
                    <div class="p-6 relative overflow-hidden h-full flex flex-col">
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-[#4361ee]/10 shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" style="color: #4361ee;">
                                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <h5 class="text-xl font-bold text-gray-800 dark:text-white-light mb-2">DHC</h5>
                            <p class="text-xs text-gray-600 dark:text-gray-400 font-medium">Dossiers Hors Casa</p>
                        </div>
                    </div>
                </div>

                <!-- Utilisateurs - Show only if user has UTIL permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-[#4361ee]/20 min-h-[180px] bg-white dark:bg-[#0e1726]"
                    *ngIf="hasAccess('UTIL')" (click)="navigateToRoute('/utilisateurs', 'UTIL')">
                    <div class="p-6 relative overflow-hidden h-full flex flex-col">
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-[#4361ee]/10 shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" style="color: #4361ee;">
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <h5 class="text-xl font-bold text-gray-800 dark:text-white-light mb-2">Utilisateurs</h5>
                            <p class="text-xs text-gray-600 dark:text-gray-400 font-medium">Gestion Utilisateurs</p>
                        </div>
                    </div>
                </div>

                <!-- Adhérents - Show only if user has ADHP permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-[#4361ee]/20 min-h-[180px] bg-white dark:bg-[#0e1726]"
                    *ngIf="hasAccess('ADHP')" (click)="navigateToRoute('/adherents', 'ADHP')">
                    <div class="p-6 relative overflow-hidden h-full flex flex-col">
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-[#4361ee]/10 shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" style="color: #4361ee;">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <h5 class="text-xl font-bold text-gray-800 dark:text-white-light mb-2">Adhérents</h5>
                            <p class="text-xs text-gray-600 dark:text-gray-400 font-medium">Liste Adhérents</p>
                        </div>
                    </div>
                </div>

                <!-- Partenaires - Show only if user has PART permission -->
                <div class="panel h-full p-0 cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-lg border border-transparent hover:border-[#4361ee]/20 min-h-[180px] bg-white dark:bg-[#0e1726]"
                    *ngIf="hasAccess('PART')" (click)="navigateToRoute('/partenaires', 'PART')">
                    <div class="p-6 relative overflow-hidden h-full flex flex-col">
                        <div class="relative z-10">
                            <div class="flex items-center justify-between mb-4">
                                <div class="flex h-12 w-12 items-center justify-center rounded-xl bg-[#4361ee]/10 shadow-lg">
                                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" style="color: #4361ee;">
                                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <h5 class="text-xl font-bold text-gray-800 dark:text-white-light mb-2">Partenaires</h5>
                            <p class="text-xs text-gray-600 dark:text-gray-400 font-medium">Liste Partenaires</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- PART 6/6: Statistics Summary & Footer -->
        <!-- Statistics Summary - Only show if user has access to any section -->
        <div class="grid gap-6 lg:grid-cols-2" *ngIf="shouldShowAdherentSection() || shouldShowPartenaireSection()">
            <!-- Adhérent Overview - Only show if user has access to adherent modules -->
            <div class="panel p-6" *ngIf="shouldShowAdherentSection()">
                <div class="flex items-center justify-between mb-4">
                    <h4 class="text-lg font-bold text-gray-800 dark:text-white-light">Résumé Adhérent</h4>
                    <div class="text-sm text-gray-500 dark:text-white-dark">Total des demandes</div>
                </div>
                <div class="text-3xl font-bold text-primary mb-2">{{ getTotalAdherentRequests() }}</div>
                <div class="space-y-2">
                    <div class="flex items-center justify-between text-sm" *ngIf="hasAccess('FDSA')">
                        <span class="text-gray-600 dark:text-white-dark">Soins ambulatoires</span>
                        <span class="font-semibold text-warning">{{ adherentStats?.feuillesSoins || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between text-sm" *ngIf="hasAccess('PECA')">
                        <span class="text-gray-600 dark:text-white-dark">Prises en charge</span>
                        <span class="font-semibold text-success">{{ adherentStats?.prisesEnCharge || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between text-sm" *ngIf="hasAccess('ADHA')">
                        <span class="text-gray-600 dark:text-white-dark">Famille et Adhésion</span>
                        <span class="font-semibold text-info">{{ adherentStats?.familleAdhesion || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between text-sm" *ngIf="hasAccess('ALDA')">
                        <span class="text-gray-600 dark:text-white-dark">Affections L.D.</span>
                        <span class="font-semibold text-danger">{{ adherentStats?.affectionsLongueDuree || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between text-sm" *ngIf="hasAccess('EPA')">
                        <span class="text-gray-600 dark:text-white-dark">Ententes Préalables</span>
                        <span class="font-semibold text-purple-500">{{ adherentStats?.ententesPrealables || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between text-sm" *ngIf="hasAccess('RECA')">
                        <span class="text-gray-600 dark:text-white-dark">Réclamations</span>
                        <span class="font-semibold text-secondary">{{ adherentStats?.reclamations || 0 }}</span>
                    </div>
                </div>
            </div>

            <!-- Partenaire Overview - Only show if user has access to partenaire modules -->
            <div class="panel p-6" *ngIf="shouldShowPartenaireSection()">
                <div class="flex items-center justify-between mb-4">
                    <h4 class="text-lg font-bold text-gray-800 dark:text-white-light">Résumé Partenaire</h4>
                    <div class="text-sm text-gray-500 dark:text-white-dark">Total des demandes</div>
                </div>
                <div class="text-3xl font-bold text-purple-500 mb-2">{{ getTotalPartenaireRequests() }}</div>
                <div class="space-y-2">
                    <div class="flex items-center justify-between text-sm" *ngIf="hasAccess('PECP')">
                        <span class="text-gray-600 dark:text-white-dark">Prises en charge</span>
                        <span class="font-semibold text-success">{{ partenaireStats?.prisesEnCharge || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between text-sm" *ngIf="hasAccess('INFO')">
                        <span class="text-gray-600 dark:text-white-dark">Informations</span>
                        <span class="font-semibold text-info">{{ partenaireStats?.informations || 0 }}</span>
                    </div>
                    <div class="flex items-center justify-between text-sm" *ngIf="hasAccess('RECP')">
                        <span class="text-gray-600 dark:text-white-dark">Réclamations</span>
                        <span class="font-semibold text-secondary">{{ partenaireStats?.reclamations || 0 }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- No Access Message - Show if user has no access to any section -->
        <div class="panel p-8 text-center"
            *ngIf="!shouldShowAdherentSection() && !shouldShowPartenaireSection() && !shouldShowActionsRapides()">
            <div class="mb-4">
                <svg class="w-16 h-16 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 15v2m0 0v2m0-2h2m-2 0H10m9-6V9a3 3 0 00-3-3H8a3 3 0 00-3 3v6a1 1 0 001 1h14a1 1 0 001-1z">
                    </path>
                </svg>
            </div>
            <h3 class="text-xl font-semibold text-gray-600 dark:text-white-dark mb-2">Accès limité</h3>
            <p class="text-gray-500 dark:text-white-dark">
                Vous n'avez actuellement accès à aucun module du tableau de bord.<br>
                Contactez votre administrateur pour obtenir les permissions nécessaires.
            </p>
        </div>
    </div>
</div>